import { useQuery } from '@tanstack/react-query';
import { getBtc15Bankroll } from '../lib/apiClient';

// The ledger moves at most once per 15-minute round.
const STALE_TIME_MS = 5 * 60_000;

/** The permanent paper-bankroll ledger. Hypothetical only. */
export function useBtc15Bankroll() {
  return useQuery({
    queryKey: ['btc15-bankroll'],
    queryFn: getBtc15Bankroll,
    staleTime: STALE_TIME_MS,
    refetchInterval: STALE_TIME_MS,
  });
}
